// components/partials/Footer.jsx
import React from 'react';
import { Link } from "react-router-dom";
import { RiFacebookFill } from "react-icons/ri";
import { FaTelegramPlane } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";

const Footer = () => {
  return (
    <footer
      className="d-flex flex-wrap align-items-center justify-content-center py-3 border-top"
      style={{ backgroundColor: "#f9fafb", marginTop: "auto" }}>
      <div className="text-center">
        <div className="d-flex justify-content-center gap-3 mb-2">
          <Link to="#" style={{ color: "#6b7280", fontSize: "1.25rem" }}>
            <RiFacebookFill />
          </Link>
          <Link to="#" style={{ color: "#6b7280", fontSize: "1.25rem" }}>
            <FaTelegramPlane />
          </Link>
          <Link to="#" style={{ color: "#6b7280", fontSize: "1.25rem" }}>
            <AiFillInstagram />
          </Link>
        </div>
        <p className="text-muted mb-0" style={{ fontSize: "1.25rem" }}>
          Inventory Management App — YEBRHAN INC. &copy; All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;